module.exports = __webpack_public_path__ + "static/img/section-3-image.675aa004.png";